import { useCallback, useEffect } from "react";

import {
  organizationAddressDataSelector,
  getOrganizationAddress
} from "Reducers/organization/address";
import { useAppDispatch, useAppSelector } from "Store/hooks";

import type { OrganizationAddress } from "Api/organizations/address/types";

export const useOrganizationAddress = (
  organizationId: string,
  options?: Partial<{ onAddressLoads: (address: OrganizationAddress) => void }>
) => {
  const dispatch = useAppDispatch();
  const { address, loadingUpdate } = useAppSelector(state =>
    organizationAddressDataSelector(state, { organizationId })
  );

  const load = useCallback(async () => {
    const response = await dispatch(getOrganizationAddress({ organizationId }));
    const addressResponse = response.payload;

    if (options?.onAddressLoads) options.onAddressLoads(addressResponse);
  }, [dispatch, options, organizationId]);

  useEffect(() => {
    if (!address) load();
  }, [load, address]);

  return {
    address: address,
    isLoading: loadingUpdate,
    load
  };
};
